import { useQuery } from '@tanstack/react-query';
import { fetchDocumentImportReviews } from './documentImportReviews.js';

export function useDocumentImportReviews(
  tenantId: string | null | undefined,
  businessId: string | null | undefined,
) {
  return useQuery({
    queryKey: ['document-import-reviews-v1', tenantId, businessId],
    enabled: !!tenantId && !!businessId,
    queryFn: () => fetchDocumentImportReviews({
      tenantId: tenantId!,
      businessId: businessId!,
    }),
    refetchInterval: 15_000,
    refetchOnMount: 'always',
    refetchOnReconnect: 'always',
  });
}
